/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PendingFreelancerUmbrellaInvitationResource
 */
export interface PendingFreelancerUmbrellaInvitationResource {
    /**
     * Unique ID of the invitation
     * @type {string}
     * @memberof PendingFreelancerUmbrellaInvitationResource
     */
    id: string;
    /**
     * Email address of the umbrella company used in the invitation
     * @type {string}
     * @memberof PendingFreelancerUmbrellaInvitationResource
     */
    umbrellaCompanyEmail: string;
    /**
     * Date and time the invitation email was sent
     * @type {Date}
     * @memberof PendingFreelancerUmbrellaInvitationResource
     */
    emailSentAt: Date;
}

/**
 * Check if a given object implements the PendingFreelancerUmbrellaInvitationResource interface.
 */
export function instanceOfPendingFreelancerUmbrellaInvitationResource(value: object): value is PendingFreelancerUmbrellaInvitationResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('umbrellaCompanyEmail' in value) || value['umbrellaCompanyEmail'] === undefined) return false;
    if (!('emailSentAt' in value) || value['emailSentAt'] === undefined) return false;
    return true;
}

export function PendingFreelancerUmbrellaInvitationResourceFromJSON(json: any): PendingFreelancerUmbrellaInvitationResource {
    return PendingFreelancerUmbrellaInvitationResourceFromJSONTyped(json, false);
}

export function PendingFreelancerUmbrellaInvitationResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PendingFreelancerUmbrellaInvitationResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'umbrellaCompanyEmail': json['umbrellaCompanyEmail'],
        'emailSentAt': (new Date(json['emailSentAt'])),
    };
}

export function PendingFreelancerUmbrellaInvitationResourceToJSON(value?: PendingFreelancerUmbrellaInvitationResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'umbrellaCompanyEmail': value['umbrellaCompanyEmail'],
        'emailSentAt': ((value['emailSentAt']).toISOString()),
    };
}

